<template>
  <ion-page>
    <ion-content color="primary" class="ion-padding welcome-wrapper">
      <section class="welcome-wrapper__body d-flex justify-space-center w-100 h-100">
        <div class="content d-flex flex-column justify-space-evenly h-100 align-center w-100">
          <div class="welcome-wrapper__logo ion-justify-content-center">
            <ion-img :src="arriboLogo" alt="Arribo Logo" data-test="logo"></ion-img>
          </div>
          <div class="welcome-wrapper__hero ion-justify-content-center">
            <ion-img :src="arriboHero" alt="Arribo Hero" data-test="hero"></ion-img>
          </div>

          <div class="welcome-wrapper__actions">
            <ion-button
              fill="solid"
              expand="block"
              size="large"
              color="accent"
              class="text-lg text-weight-bold"
              @click="goToSignUp"
            >
              {{ t('welcome.createAccount') }}
            </ion-button>
            <ion-button
              fill="outline"
              expand="block"
              size="large"
              color="white"
              class="text-lg text-weight-bold mt-xs"
              @click="goTo('Explore')"
            >
              {{ t('welcome.continueGuest') }}
            </ion-button>
            <ion-button
              fill="clear"
              class="text-lg text-underline mt-lg mb-lg"
              color="white"
              expand="block"
              size="small"
              @click="goTo('login')"
            >
              {{ t('welcome.haveAnAccount') }}
            </ion-button>
          </div>
        </div>
      </section>
    </ion-content>
  </ion-page>
</template>
<script setup lang="ts">
  import { IonPage, IonContent, IonImg, IonButton } from '@ionic/vue';
  import arriboLogo from '@/assets/images/arribo-logo.svg';
  import arriboHero from '@/assets/images/arribo-hero.svg';
  import { useI18n } from 'vue-i18n';
  import { useAuth } from '@/composables/useAuth';

  const { t } = useI18n();
  const { goTo } = useAuth();

  const goToSignUp = () => {
    goTo('signUp');
  };
</script>
<style scoped lang="scss">
  .welcome-wrapper {
    &__logo {
      width: 100%;
      display: flex;
      justify-content: center;

      ion-img {
        width: 190px;
      }
    }

    &__hero {
      width: 100%;
      display: flex;
      justify-content: center;
      max-height: calc(500px - 10%);

      ion-img {
        width: 85%;
      }
    }
  }
</style>
